<micro-select-combo #sel
                    placeholder="Access Category"
                    routerBase="/access/categories"
                    [mode]="mode"
                    [(id)]="categoryId"
                    (idChange)="change($event)"
                    [options]="options"
                    [required]="required"
                    [disabled]="disabled"
                    [sizeDynamically]="sizeDynamically"
                    [allLabel]="allLabel"
                    [allId]="allId"
                    [requires]="requiredLabel"
                    [jump]="jump">
</micro-select-combo>
